import C from "../constants";
import { updateUsersInvestorsAfterRemoveMember } from "../helpers/utils";

const initialState = {
  dealsList: [],
  dealsData: {},
  dealMenuAreDisplayed: true,
  waitResponse: false,
  error: false,
};

export default function (state, action) {
  switch (action.type) {
    case C.DEAL_CREATE:
    case C.GET_DEALS_LIST_REQUEST:
    case C.GET_DEAL_REQUEST:
    case C.INVITE_MEMBER:
    case C.DEAL_UPDATE:
    case C.DEAL_COMPANY_UPDATE:
    case C.UPDATE_INVESTOR_MEMBERS:
    case C.DEAL_COMPANY_MEMBER_UPDATE_REQUEST:
    case C.REMOVE_INVITE_MEMBER:
    case C.SEND_PERSON_INVITATION:
    case C.SIGNATURE_REQUEST:
    case C.CREATE_SIGNERS:
    case C.UPDATE_SIGNERS:
      return {
        ...state,
        created: false,
        updated: false,
        removed: false,
        loaded: false,
        formErrors: undefined,
        persons: [],
        isSignatureReminder: false,
        isSignatureRequest: false,
        signerCreated: false,
        signerUpdated: false,
      };
    case C.DEAL_CREATE_FAIL:
    case C.GET_DEALS_LIST_FAIL:
    case C.GET_DEAL_FAIL:
    case C.INVITE_MEMBER_FAIL:
    case C.DEAL_UPDATE_FAIL:
    case C.UPDATE_INVESTOR_MEMBERS_FAIL:
    case C.DEAL_COMPANY_MEMBER_UPDATE_FAIL:
    case C.REMOVE_INVITE_MEMBER_FAIL:
    case C.SEND_PERSON_INVITATION_FAIL:
    case C.SIGNATURE_REQUEST_FAIL:
    case C.CREATE_SIGNERS_FAIL:
    case C.UPDATE_SIGNERS_FAIL:
      const { formErrors } = action.error;
      return {
        ...state,
        formErrors: formErrors || undefined,
      };
    case C.DEAL_CREATE_SUCCESS:
    case C.GET_DEAL_SUCCESS:
      const { result: deal } = action;
      return {
        ...state,
        created: true,
        dealsData: {
          ...state.dealsData,
          [deal.id]: {
            ...deal,
          },
        },
      };
    case C.DEAL_UPDATE_SUCCESS:
      const { dealId: d, data: newData } = action.result;
      return {
        ...state,
        updated: true,
        dealsData: {
          ...state.dealsData,
          [d]: {
            ...state.dealsData[d],
            ...newData,
            company: {
              ...state.dealsData[d].company,
              ...newData.company,
            },
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === d) {
            res.push({
              ...d,
              ...newData,
              company: {
                ...d.company,
                ...newData.company,
              },
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    case C.INVITE_MEMBER_SUCCESS:
      const { member, dealId: dId } = action.result;
      return {
        ...state,
        updated: true,
        dealsData: {
          ...state.dealsData,
          [dId]: {
            ...state.dealsData[dId],
            investors: state.dealsData[dId].investors.reduce((res, i) => {
              if (i.id === member.dealInvestorMember.investor_id) {
                res.push({
                  ...i,
                  deal_investor_members: [
                    ...i.deal_investor_members,
                    member.dealInvestorMember,
                  ],
                });
              } else {
                res.push({
                  ...i,
                });
              }
              return res;
            }, []),
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === dId) {
            res.push({
              ...d,
              investors: d.investors.reduce((res2, i) => {
                if (i.id === member.dealInvestorMember.investor_id) {
                  res2.push({
                    ...i,
                    deal_investor_members: [
                      ...i.deal_investor_members,
                      member.dealInvestorMember,
                    ],
                  });
                } else {
                  res2.push({
                    ...i,
                  });
                }
                return res2;
              }, []),
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    case C.REMOVE_INVITE_MEMBER_SUCCESS:
      const { removedMember, investorId: invId, dealId: ddId } = action.result;
      const newInvestors = state.dealsData[ddId].investors.reduce((res, i) => {
        if (i.id === invId) {
          i.deal_investor_members = updateUsersInvestorsAfterRemoveMember(
            i.deal_investor_members,
            removedMember
          );
        }
        res.push({
          ...i,
        });
        return res;
      }, []);
      return {
        ...state,
        updated: true,
        dealsData: {
          ...state.dealsData,
          [ddId]: {
            ...state.dealsData[ddId],
            investors: newInvestors,
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === dId) {
            res.push({
              ...d,
              investors: newInvestors,
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    case C.GET_DEALS_LIST_SUCCESS:
      const { result: deals } = action;

      const dealsData = deals.reduce((res, c) => {
        res[c.id] = c;
        return res;
      }, {});

      return {
        ...state,
        dealsData: dealsData,
        dealsList: deals,
        loaded: true,
      };
    case C.DEAL_COMPANY_MEMBER_UPDATE_SUCCESS:
      const { dealId: dealUnique } = action.result;
      return {
        ...state,
        updated: true,
        dealsData: {
          ...state.dealsData,
          [dealUnique]: {
            ...state.dealsData[dealUnique],
            company: {
              ...state.dealsData[dealUnique].company,
            },
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === dealUnique) {
            res.push({
              ...d,
              company: {
                ...d.company,
              },
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    case C.UPDATE_INVESTOR_MEMBERS_SUCCESS:
      const { dealId: dealUID, investorId: iId, changes } = action.result;
      const removedDealLegalEntityInvestments = changes.removed.reduce(
        (res, obj) => {
          res.push(obj.dealLegalEntityInvestmentId);
          return res;
        },
        []
      );
      const removedInvestorMembers = changes.removed.reduce((res, obj) => {
        res.push(obj.dealInvestorMemberId);
        return res;
      }, []);
      const updatedInvestors = state.dealsData[+dealUID].investors.reduce(
        (res, i) => {
          if (i.id === +iId) {
            res.push({
              ...i,
              deal_legal_entity_investments: [
                ...i.deal_legal_entity_investments
                  .filter(
                    (le) =>
                      removedDealLegalEntityInvestments.indexOf(le.id) === -1
                  )
                  .reduce((memo, le) => {
                    const obj = changes.updated.find((up) => up.id === le.id);
                    if (obj) {
                      memo.push({
                        ...le,
                        ...obj.data,
                        legal_entity: {
                          ...le.legal_entity,
                          name: obj.data.investing_entity_legal_name,
                        },
                      });
                    } else {
                      memo.push({
                        ...le,
                      });
                    }
                    return memo;
                  }, []),
                ...changes.created.dealLegalEntityInvestments,
              ],
              deal_investor_members: [
                ...i.deal_investor_members
                  .filter(
                    (member) => removedInvestorMembers.indexOf(member.id) === -1
                  )
                  .reduce((memo, member) => {
                    const obj = changes.updated.find(
                      (up) => up.id === member.id
                    );
                    if (obj) {
                      memo.push({
                        ...member,
                        ...obj.data,
                      });
                    } else {
                      memo.push({
                        ...member,
                      });
                    }
                    return memo;
                  }, []),
                ...changes.created.dealInvestorMembers,
              ],
            });
          } else {
            res.push({
              ...i,
            });
          }
          return res;
        },
        []
      );

      return {
        ...state,
        updated: true,
        dealsData: {
          ...state.dealsData,
          [dealUID]: {
            ...state.dealsData[dealUID],
            investors: updatedInvestors,
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === dealUID) {
            res.push({
              ...d,
              investors: updatedInvestors,
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    case C.SEND_PERSON_INVITATION_SUCCESS:
      const { dealId: dealuid } = action.result;

      return {
        ...state,
        updated: true,
        dealsData: {
          ...state.dealsData,
          [dealuid]: {
            ...state.dealsData[dealuid],
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === dealuid) {
            res.push({
              ...d,
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    case C.RESET_DEAL_ERRORS: {
      return {
        ...state,
        formErrors: undefined,
      };
    }
    case C.GET_DOCUMENTS_SIGNERS_SUCCESS: {
      const signers = action.result.response;
      return {
        ...state,
        dealsData: {
          ...state.dealsData,
          [action.result.dealId]: {
            ...state.dealsData[action.result.dealId],
            signers: [...signers],
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === action.result.dealId) {
            res.push({
              ...d,
              signers: [...signers],
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    }
    case C.ADD_SIGNERS_SUCCESS: {
      const addedSigners = action.result.response;

      const newSigners = [
        ...state.dealsData[action.result.dealId].signers,
        ...addedSigners,
      ];

      return {
        ...state,
        dealsData: {
          ...state.dealsData,
          [action.result.dealId]: {
            ...state.dealsData[action.result.dealId],
            signers: [...newSigners],
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === action.result.dealId) {
            res.push({
              ...d,
              signers: [...d.signers, ...addedSigners],
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    }
    case C.REMOVE_SIGNERS_SUCCESS: {
      const signersIds = action.result.signersIds;
      const newSigners = state.dealsData[action.result.dealId].signers.filter(
        (item) => signersIds.indexOf(item.id) === -1
      );

      return {
        ...state,
        dealsData: {
          ...state.dealsData,
          [action.result.dealId]: {
            ...state.dealsData[action.result.dealId],
            signers: [...newSigners],
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === action.result.dealId) {
            res.push({
              ...d,
              signers: [...newSigners],
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
      };
    }
    case C.SIGNATURE_REQUEST_SUCCESS:
      const signersIds = action.result.signersIds;
      const newSigners = state.dealsData[action.result.dealId].signers.reduce(
        (res, item) => {
          if (signersIds.indexOf(item.id) > -1) {
            res.push({
              ...item,
              status: "Requested",
            });
          } else {
            res.push({
              ...item,
            });
          }
          return res;
        },
        []
      );

      return {
        ...state,
        dealsData: {
          ...state.dealsData,
          [action.result.dealId]: {
            ...state.dealsData[action.result.dealId],
            signers: [...newSigners],
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === action.result.dealId) {
            res.push({
              ...d,
              signers: [...newSigners],
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
        isSignatureRequest: action.result.userId,
      };
    case C.SIGNATURE_REMINDER_SUCCESS:
      return {
        ...state,
        isSignatureReminder: action.result,
      };
    case C.CREATE_SIGNERS_SUCCESS:
      const { legalEntity, company } = action.result;

      const UpdatingOfInvestors = state.dealsData[
        action.result.dealId
      ].investors.reduce((res, i) => {
        res.push({
          ...i,
          deal_legal_entity_investments: i.deal_legal_entity_investments.reduce(
            (res2, dle) => {
              if (action.result.dealLegalEntityInvestmentId === dle.id) {
                res2.push({
                  ...dle,
                  legal_entity: {
                    ...dle.legal_entity,
                    ...legalEntity,
                    company: company,
                  },
                });
              } else {
                res2.push({
                  ...dle,
                });
              }
              return res2;
            },
            []
          ),
        });
        return res;
      }, []);

      return {
        ...state,
        dealsData: {
          ...state.dealsData,
          [action.result.dealId]: {
            ...state.dealsData[action.result.dealId],
            investors: UpdatingOfInvestors,
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === action.result.dealId) {
            res.push({
              ...d,
              investors: UpdatingOfInvestors,
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
        signerCreated: true,
      };
    case C.UPDATE_SIGNERS_SUCCESS:
      const UpdatingInvestors = state.dealsData[
        action.result.dealId
      ].investors.reduce((res, i) => {
        res.push({
          ...i,
          deal_legal_entity_investments: i.deal_legal_entity_investments.reduce(
            (res2, dle) => {
              if (action.result.dealLegalEntityInvestmentId === dle.id) {
                res2.push({
                  ...dle,
                  legal_entity: {
                    ...dle.legal_entity,
                    s_block: {
                      ...dle.legal_entity.s_block,
                      ...action.result.signature,
                      person: {
                        ...dle.legal_entity.s_block.person,
                        ...action.result.person,
                      },
                    },
                    company: {
                      ...dle.legal_entity.company,
                      ...action.result.company,
                    },
                  },
                });
              } else {
                res2.push({
                  ...dle,
                });
              }
              return res2;
            },
            []
          ),
        });
        return res;
      }, []);

      return {
        ...state,
        dealsData: {
          ...state.dealsData,
          [action.result.dealId]: {
            ...state.dealsData[action.result.dealId],
            investors: UpdatingInvestors,
          },
        },
        dealsList: state.dealsList.reduce((res, d) => {
          if (d.id === action.result.dealId) {
            res.push({
              ...d,
              investors: UpdatingInvestors,
            });
          } else {
            res.push({
              ...d,
            });
          }
          return res;
        }, []),
        signerUpdated: true,
      };
    default:
      return state || initialState;
  }
}
